$(function () {
    $('#savefile').on('show.bs.modal', function () {
        var modal = $(this);
        var assignment_title  = $(modal).find('select[name="title_id"]');
        var upload_form       = $(modal).find('form');
        var duplicate_warning = $(modal).find('.no-duplicates-allowed');
        var anonymous_warning = $(modal).find('.anonymous-marking');

        $(duplicate_warning).hide();
        $(anonymous_warning).hide();

        $(assignment_title).on('change', function () {
            // Show the warning about duplicate submissions if the student
            // Is about to submit to an assignment that doesn't allow
            // Duplicate submissions
            if ($(this).find(':selected').data('duplicates') == 0) {
                $(duplicate_warning).show();
            } else {
                $(duplicate_warning).hide();
            }

            if ($(this).find(':selected').data('anonymous') === 1) {
                $(anonymous_warning).show();
            } else {
                $(anonymous_warning).hide();
            }
        });
        $.validator.addMethod('checkTitle', function (value, element, param) {
            if (value === '0') {
                return false;
            }

            return true;
        }, 'Please select an assigment');
        $(upload_form).validate({
            ignore: ':hidden, [contenteditable="true"]:not([name])',
            debug: false,
            errorClass: 'danger',
            rules: {
                title_id: { required: true },
                userfile: { required: true },
                group: { required: true },
            },
            submitHandler: function (form) {
                form.submit();
            },
        });
    });

    $('#eportfolio-feedback').on('show.bs.modal', function (e) {
        var file = $(e.relatedTarget).data('file');
        var gradeMark = file.feedback.grade === null ? '' : '<strong>Mark: </strong>' + file.feedback.grade;
        $('.file-title').empty().append(file.title);
        $('.heading span').empty().append(' (' + file.feedback.lastmodifiedby_realname + ')');
        $('.feedback-date').empty().append('<small>Posted:' + dayjs(parseInt(file.feedback.lastmodifieddate) * 1000).format(LONGDATE + ' ' + TIME) + '</small>');
        $('.feedback-grade').empty().append(gradeMark);
        $('.feedback-replace').empty().append('<strong>Feedback: </strong>' + file.feedback.feedback.replace('\n', '<br>'));
    });
});
